import { isDesktopRuntime } from "./desktop";

export const productionWebOrigin = "https://knowledge.northernlogic.ai";
export const stagingWebOrigin = "https://nlkb-web-staging.pages.dev";
export const productionApiOrigin = "https://api.northernlogic.ai";
export const stagingApiOrigin = "https://api-staging.northernlogic.ai";

export function publicPageOriginFor(input: {
  readonly desktop: boolean;
  readonly packaged: boolean;
  readonly pageOrigin: string;
}): string {
  if (input.desktop && input.packaged) {
    return productionWebOrigin;
  }
  return input.pageOrigin;
}

export function publicPageOrigin(): string {
  return publicPageOriginFor({
    desktop: isDesktopRuntime(),
    packaged: import.meta.env.PROD,
    pageOrigin: window.location.origin,
  });
}

export function publicShareOrigin(): string {
  if (isDesktopRuntime()) {
    return import.meta.env.DEV ? "http://localhost:5173" : productionWebOrigin;
  }
  return window.location.origin;
}

export function publicShareUrl(token: string): string {
  return `${publicShareOrigin()}/s/${token}`;
}

export function inAppContentUrl(
  organizationId: string,
  vaultId: string,
  fileId?: string,
): string {
  const path =
    fileId === undefined
      ? `/org/${organizationId}/knowledge/${vaultId}`
      : `/org/${organizationId}/knowledge/${vaultId}/${fileId}`;
  return `${publicShareOrigin()}${path}`;
}

export function shareMailtoHref(url: string, title: string): string {
  const subject = encodeURIComponent(`Shared: ${title}`);
  const body = encodeURIComponent(
    `Read-only link:\n${url}\n\nAnyone who opens this can view the current Markdown.`,
  );
  return `mailto:?subject=${subject}&body=${body}`;
}
